import { gql } from 'apollo-angular';

// Query to get a single equipment counting journal by ID (non-paginated)
export const QUERY_GetEquipmentCountingJournalById = gql`
  query ($id: String!) {
    getEquipmentCountingJournal(id: $id) {
      id
      journalNum
      name
      externalId
      externalVersionId
      locationNum
      countDate
      status
      notes
      description
      lineCount
      countedCount
      countNotFound
      countWaitingCount
      countAdded
      countOtherLocation
      countMissing
      type
      blindCount
      requireConfirmSerial
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`;
